module.exports = "pegasus/assets/graycircle-google.gif";